<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix +  ' > ' +  title ">
        <ApoliceSeguroIBPList :prefix=" prefix" :id="id"></ApoliceSeguroIBPList>
    </b-modal>
</template>

<script>

import ApoliceSeguroIBPList from '@/modules/patrimonio/apolice-seguro-ibp/ApoliceSeguroIBPList.vue';

export default {
    name: "ModalApoliceSeguroIBP",
    components: {
        ApoliceSeguroIBPList
    },
    props: {
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Apólice Seguro",
        },
        id: Number,
    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>